// extracted by mini-css-extract-plugin
export default {"formContainer":"form_formContainer__Gx0CJ","form":"form_form__XP4L4","inputs":"form_inputs__k9qtq"};